import {dedupingMixin} from '@polymer/polymer/lib/utils/mixin';
import {GestureEventListeners} from '@polymer/polymer/lib/mixins/gesture-event-listeners';
import * as Gestures from '@polymer/polymer/lib/utils/gestures';

/**
 * @polymer
 * @mixinFunction
 **/
export const ResizableBehavior = dedupingMixin((superClass) => class extends GestureEventListeners(superClass) {
  static get properties() {
    return {
      resizableEnabled: {type: Boolean, value: true, observer: 'resizableEnabledChanged'},
      resizableParentElement: Object,
      resizableHandleElements: {type: Array, observer: 'resizableHandleElementsChanged'}
    };
  }

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('resizableResizeElement', this.handleResizableResizeElement);
    this.addEventListener('resizableResizeElementEnded', this.handleResizableResizeElementEnded);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.removeEventListener('resizableResizeElement', this.handleResizableResizeElement);
    this.removeEventListener('resizableResizeElementEnded', this.handleResizableResizeElementEnded);

    if (this.resizableHandleElements && Array.isArray(this.resizableHandleElements)) {
      this.resizableHandleElements.forEach((item) => {
        Gestures.removeListener(item.element, 'down', this.handleResizableElementDown.bind(this));
        Gestures.removeListener(item.element, 'track', this.handleResizableElementTrack.bind(this));
      });
    }
    this.resizableParentElement = null;
    this.resizableHandleElements = null;
  }


  /**
   * Must be implemented on the parent component.
   */
  handleResizableResizeElement() {
    console.warn('%cResizable Behavior:', 'background: #fc0; color: #000', 'Method `handleResizableResizeElement` not defined.');
  }

  /**
   * Must be implemented on the parent component.
   */
  handleResizableResizeElementEnded() {
    console.warn('%cResizable Behavior:', 'background: #fc0; color: #000', 'Method `handleResizableResizeElementEnded` not defined.');
  }

  resizableEnabledChanged(newValue) {
    if (this.resizableHandleElements) {
      this.resizableHandleElements.forEach((item) => {
        item.element.style.display = (newValue ? '' : 'none');
      });
    }
  }

  resizableHandleElementsChanged(newValue, oldValue) {
    if (oldValue && Array.isArray(oldValue)) {
      oldValue.forEach((item) => {
        Gestures.removeListener(item.element, 'down', this.handleResizableElementDown.bind(this));
        Gestures.removeListener(item.element, 'track', this.handleResizableElementTrack.bind(this));
      });
    }

    if (newValue && Array.isArray(newValue)) {
      newValue.forEach((item) => {
        item.element.dataset.direction = item.direction;
        Gestures.addListener(item.element, 'down', this.handleResizableElementDown.bind(this));
        Gestures.addListener(item.element, 'track', this.handleResizableElementTrack.bind(this));
      });
    }
  }

  handleResizableElementDown(event) {
    event.preventDefault();
  }

  handleResizableElementTrack(event) {
    if (event.detail.state === 'start') {
      let parentElement = this.resizableParentElement || this;
      this._resizableStartWidth = parseInt(window.getComputedStyle(parentElement, null).getPropertyValue('width'), 10);
      this._resizableStartHeight = parseInt(window.getComputedStyle(parentElement, null).getPropertyValue('height'), 10);
      this._resizableStartTop = parseInt(window.getComputedStyle(parentElement, null).getPropertyValue('top'), 10);
      this._resizableStartLeft = parseInt(window.getComputedStyle(parentElement, null).getPropertyValue('left'), 10);
    }
    let handle = getEventTarget(event), newTop, newLeft, newWidth, newHeight;

    switch (handle.dataset.direction) {
      case 'n':
        newHeight = this._resizableStartHeight - event.detail.dy;
        newTop = this._resizableStartTop + event.detail.dy;
        break;
      case 'e':
        newWidth = this._resizableStartWidth + event.detail.dx;
        break;
      case 's':
        newHeight = this._resizableStartHeight + event.detail.dy;
        break;
      case 'w':
        newWidth = this._resizableStartWidth - event.detail.dx;
        newLeft = this._resizableStartLeft + event.detail.dx;
        break;
      case 'nw':
        newHeight = this._resizableStartHeight - event.detail.dy;
        newTop = this._resizableStartTop + event.detail.dy;
        newWidth = this._resizableStartWidth - event.detail.dx;
        newLeft = this._resizableStartLeft + event.detail.dx;
        break;
      case 'ne':
        newHeight = this._resizableStartHeight - event.detail.dy;
        newTop = this._resizableStartTop + event.detail.dy;
        newWidth = this._resizableStartWidth + event.detail.dx;
        break;
      case 'sw':
        newHeight = this._resizableStartHeight + event.detail.dy;
        newWidth = this._resizableStartWidth - event.detail.dx;
        newLeft = this._resizableStartLeft + event.detail.dx;
        break;
      case 'se':
        newHeight = this._resizableStartHeight + event.detail.dy;
        newWidth = this._resizableStartWidth + event.detail.dx;
        break;
    }

    this.dispatchEvent(new CustomEvent('resizableResizeElement', {
      detail: {top: newTop, left: newLeft, width: newWidth, height: newHeight}
    }));

    if (event.detail.state === 'end' && typeof this.handleResizableResizeElementEnded !== 'undefined') {
      this.dispatchEvent(new CustomEvent('resizableResizeElementEnded', {
        detail: {top: newTop, left: newLeft, width: newWidth, height: newHeight}
      }));
    }
  }
});